/**
 * feature-config flag names owned by localization
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const LOCALIZATION_FLAG_NAMES = {
  LOCALIZATION_PRECISE_COMPONENTS:
    'ff-dperf-167-precise-symbols-in-secondary-locales',
  LOCALIZATION_UPSELL_POPOVER: 'ff-local-804-upsell-dialog',
  LOG_LOCALIZATION_CHANGES: 'ff-local-815-log-localization-changes',
  LOCALIZATION_CORRUPTION_RECOVERY: 'ff-local-1109-corruption-recovery',
  LOCALIZATION_HIDE_COMPONENT_WORK_OVERLAY:
    'ff-loc-881-hide-component-localization-overlay',
  AUDIT_PANEL_UI_UPDATE: 'ff-local-1111-audit-panel-ui',
  AUTO_TRANSLATE_CMS_ON_PUBLISH_KILLSWITCH:
    'ff-local-2118-auto-translate-cms-on-publish-killswitch',
  AUTO_TRANSLATE_CMS_ON_PUBLISH_DRY_RUN:
    'ff-local-2118-auto-translate-cms-on-publish-dry-run',
  AUTO_TRANSLATE_ON_PUBLISH_KILLSWITCH:
    'ff-local-1636-auto-translate-on-publish-killswitch',
  LOG_PUBLIC_API_LOCALIZATION_ACTIONS:
    'ff-local-1430-log-public-api-localization-updates',
  UPDATE_PROXY_AUTH_SUBDIRECTORIES_FORMAT:
    'ff-local-1444-proxy-auth-updated-format',
  COMPONENT_ATOMIC_UPDATE: 'ff-local-1459-component-atomic-update',
  AUTO_SET_PRIMARY_LOCALE: 'exp-local-1469-auto-set-primary-locale',
  LOCALIZE_PAGE_CUSTOM_CODE: 'ff-local-1576-localize-page-custom-code',
  NEW_LOCALIZATION_PANEL: 'ff-local-1698-new-localization-panel',
  USE_NEW_GLOSSARY_STORAGE: 'ff-local-1707-use-new-glossary-storage',
  TRANSLATION_SERVICE_USE_OLD_GLOSSARY:
    'ff-loc-2440-translation-service-use-old-glossary',
  LOCALIZATION_LOST_TRANSLATIONS_AI_REMAP:
    'ff-local-1517-lost-translations-ai-remap',
  TARGET_LANGUAGES_ACCESS: 'ff-local-1977-target-languages-access',
  TARGET_LANGUAGES_AUTO_TRANSLATE:
    'ff-local-1977-target-languages-auto-translate',
  TRANSLATION_USAGE_METER: 'ff-local-2217-translation-usage-meter',
  TRANSLATION_WORD_LIMIT_GRACE_PERIOD_UI: 'ff-loc-2735-grace-period-ui',
  ENFORCE_TRANSLATION_WORD_LIMIT:
    'ff-local-2218-enforce-translation-word-limit',
  STRIP_COMMERCE_DRIVER_CREDENTIALS:
    'ff-local-1718-strip-commerce-driver-credentials',
  LOST_TRANSLATIONS_REPORT_KILLSWITCH:
    'ff-local-114756-lost-translations-report-killswitch',
  LOST_TRANSLATIONS_SETTINGS_ENTRY:
    'ff-local-114756-lost-translations-settings-entry',
  IN_DESIGNER_TRANSLATIONS: 'ff-local-1977-target-languages-auto-translate',
  TRANSLATION_MEMORY: 'ff-loc-2523-translation-memory',
  AUTO_TRANSLATE_CMS_IN_DESIGNER_KILLSWITCH:
    'ff-loc-2578-auto-translate-cms-in-designer-killswitch',
  AUTO_TRANSLATE_CMS_IN_DESIGNER_DRY_RUN:
    'ff-loc-2578-auto-translate-cms-in-designer-dry-run',
  AUTO_TRANSLATE_STATIC_CONTENT_KILLSWITCH:
    'ff-loc-2575-auto-translate-static-content-killswitch',
  AUTO_TRANSLATE_STATIC_CONTENT_DRY_RUN:
    'ff-loc-2575-auto-translate-static-content-dry-run',
  AUTO_TRANSLATE_PAGE_METADATA_KILLSWITCH:
    'ff-loc-2633-auto-translate-page-metadata-killswitch',
  AUTO_TRANSLATE_PAGE_METADATA_DRY_RUN:
    'ff-loc-2633-auto-translate-page-metadata-dry-run',
  AUTO_TRANSLATE_ON_PUBLISH_DRY_RUN:
    'ff-loc-2632-auto-translate-on-publish-dry-run',
  LOCALE_SWITCH_SYMBOL_REUSE_KILLSWITCH:
    'ff-loc-2605-locale-switch-symbol-reuse-killswitch',
  WORD_LIMIT_NOTIFICATION: 'ff-loc-2781-word-limit-notification',
  RETIRE_SUBMITTED_PENDING_ORDERS:
    'ff-loc-2655-retire-submitted-pending-orders',
  // Off: a rich text block whose translated tags don't match stays untranslated.
  TOLERATE_RICH_TEXT_TAG_MISMATCH:
    'ff-loc-2960-tolerate-rich-text-tag-mismatch',
  // Off: the translation prompt has no rules for CMS rich text <wN> tags.
  RICH_TEXT_TAG_PROMPT_RULES: 'ff-loc-2990-rich-text-tag-prompt-rules',
  // Off: CMS rich text blocks that lose <wN> tags are applied without relocation.
  RELOCATE_RICH_TEXT_TAGS: 'ff-loc-2990-relocate-rich-text-tags',
  // Off: CMS rich text keeps its source run order even when the translation reorders <wN> tags.
  REORDER_RICH_TEXT_TAGS: 'ff-loc-2995-reorder-rich-text-tags',
  // Off: the /dom APIs skip native elements placed in component slots.
  EXPORT_NATIVE_SLOT_CONTENT: 'ff-loc-2761-export-native-slot-content',
  // Off: canvas text units keep element ids in their inline tags, so Translation
  // Memory only hits for the same element.
  TRANSLATION_MEMORY_POSITIONAL_INLINE_TAGS:
    'ff-loc-2965-translation-memory-improve-tags-handle',
  CHECKOUT_CSP_ENFORCE: 'ff-loc-3085-checkout-csp-audit',
} as const;

export const LOCALIZATION_DYNAMIC_CONFIG_NAMES = {
  // Global DES-7843 kill switch. `{enabled: false}` restores legacy behavior.
  CANONICALIZE_LOCALIZED_OBJECT_IDS:
    'dc-des-7843-canonicalize-localized-object-ids',
} as const;
